import React, { useMemo, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import objectPath from "object-path";
import SVG from "react-inlinesvg";
import { checkIsActive, toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import Login from "../extras/Login";
import { LanguageSelectorDropdown } from "../extras/dropdowns/LanguageSelectorDropdown";
import { FormattedMessage } from "react-intl";
import { Topbar } from "../header/Topbar";
import { TopbarMobile } from "../header/TopbarMobile";
import { Button, ToggleButton } from "react-bootstrap";
import { GetLogoBusiness } from "../../../_helpers/GetLogo";
import { UserNotificationsDropdownBuss } from "../extras/dropdowns/UserNotificationsDropdownBuss";

export function HeaderMobileBus() {
  const uiService = useHtmlClassService();
  const location = useLocation();
  const [showTopbar, setShowTopbar] = useState(false);

  const layoutProps = useMemo(() => {
    return {
      headerLogo: uiService.getStickyLogo(),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      headerMenuSelfDisplay:
        objectPath.get(uiService.config, "header.menu.self.display") === true,
      headerMobileCssClasses: uiService.getClasses("header_mobile", true),
      headerMobileAttributes: uiService.getAttributes("header_mobile"),
      viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
      ulClasses: uiService.getClasses("header_menu_nav", true),
      viewLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
    };
  }, [uiService]);
  const getMenuItemActive = (url) => {
    return checkIsActive(location, url) ? "menu-item-active" : "";
  };

  return (
    <>
      {/*begin::Header Mobile*/}
      <div
      style={{backgroundColor:"black"}}
        id="kt_header_mobile"
        className={`header-mobile align-items-center ${layoutProps.headerMobileCssClasses}`}
        {...layoutProps.headerMobileAttributes}
      >
        {/*begin::Logo*/}
        {/*end::Logo*/}
        {/*begin::Toolbar*/}
        {/* <div className="d-flex align-items-center"> */}
        <Link className="pl-5" to="/">
          <img width="96" alt="logo" src={GetLogoBusiness("dark")} />
        </Link>
        {layoutProps.asideDisplay && (
          <>
            {/*begin::Aside Mobile Toggle*/}
            {/* <button className="btn p-0 burger-icon burger-icon-left" id="kt_aside_mobile_toggle">
                    <span/>
                  </button> */}
            {/*end::Aside Mobile Toggle*/}
          </>
        )}

        {layoutProps.headerMenuSelfDisplay && (
          <>
            {/*begin::Header Menu Mobile Toggle*/}
            {/* <button className="btn p-0 burger-icon ml-4" id="kt_header_mobile_toggle">
                    <span/>
                  </button> */}
            {/*end::Header Menu Mobile Toggle*/}
          </>
        )}

        {/*begin::Topbar Mobile Toggle*/}
        {/* <button
                className="btn btn-hover-text-primary p-0 ml-2"
                id="kt_header_mobile_topbar_toggle"
            >
              <span className="svg-icon svg-icon-xl">
                <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
              </span>
            </button> */}
        {/*end::Topbar Mobile Toggle*/}
        <div
          style={{
            display: "inline-flex",
            placeItems: "center",
          }}
        >
          {window.location.pathname.split("/").slice(1)[0] == "business" ? (
            <NavLink className="menu-link mx-4" to="/">
              <span className="menu-text text-light">
                <FormattedMessage id="FOOTER.PERSONAL"></FormattedMessage>
              </span>
              {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
            </NavLink>
          ) : (
            <NavLink className="menu-link mx-4" to="/business/home">
              <span className="menu-text text-light">
                <FormattedMessage id="FOOTER.Business"></FormattedMessage>
              </span>
              {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
            </NavLink>
          )}
          {layoutProps.viewUserDisplay && <Login />}
{layoutProps.viewLanguagesDisplay && <LanguageSelectorDropdown />}
          <UserNotificationsDropdownBuss/>
          {/* 
          <div onClick={() => setShowTopbar(!showTopbar)}>
            <span class="svg-icon svg-icon-light svg-icon-2x">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                // xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <title>Stockholm-icons / General / Other1</title>
                <desc>Created with Sketch.</desc>
                <defs />
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect x="0" y="0" width="24" height="24" />
                  <circle fill="#000000" cx="12" cy="5" r="2" />
                  <circle fill="#000000" cx="12" cy="12" r="2" />
                  <circle fill="#000000" cx="12" cy="19" r="2" />
                </g>
              </svg>
            </span>
          </div>
          {showTopbar && <TopbarMobile />} */}
        </div>
      </div>
      {/*end::Toolbar*/}
      {/* </div> */}
      {/*end::Header Mobile*/}
    </>
  );
}
